import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'
import { destroy, update } from 'redux/api/GroupMembers'

import * as groupActions from 'redux/actions/Groups/actions'
import { PatchGroupMemberBody } from 'types/GlobalGroup'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

function tryUpdateGroupMember(
  id: string,
  body: PatchGroupMemberBody,
  groupId: string
) {
  return (dispatch: Dispatch) => {
    dispatch(groupActions.updateMember())

    update(id, body)
      .then((response) => {
        dispatch(
          groupActions.updateMemberSuccess({
            member: response.data.data,
            groupId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.GroupUpdated))
      })
      .catch(() => {
        dispatch(groupActions.updateMemberFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.GroupUpdatedFailed))
      })
  }
}

function tryDeleteGroupMember(
  id: string,
  groupId: string,
  isSelfService = false
) {
  return (dispatch: Dispatch) => {
    dispatch(groupActions.deleteMember())

    destroy(id)
      .then(() => {
        dispatch(groupActions.deleteMemberSuccess({ id, groupId }))

        dispatch(
          toggleSnackbarOpen(
            isSelfService
              ? SnackbarMessage.YouLeftGroup
              : SnackbarMessage.GroupUpdated
          )
        )
      })
      .catch(() => {
        dispatch(groupActions.deleteMemberFailed())

        dispatch(
          toggleSnackbarOpen(
            isSelfService
              ? SnackbarMessage.YouLeftGroupFailed
              : SnackbarMessage.GroupUpdatedFailed
          )
        )
      })
  }
}

export const useGroupMemberActions = () => {
  return {
    tryUpdateGroupMember: useThunkActions(tryUpdateGroupMember),
    tryDeleteGroupMember: useThunkActions(tryDeleteGroupMember)
  }
}
